import type { AxiosResponse } from 'axios';

import { apiSession } from 'services/config';

export async function logoutSession(refreshToken: string): Promise<AxiosResponse<void>> {
  return apiSession.post('/api/sessions/logout', { refreshToken });
}
